var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 10H3V38H45V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3323 33.4111H3.74219V37.2222H44.3323V33.4111Z",
    fill: "#FCB316"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3323 10.7778H3.74219V14.5889H44.3323V10.7778Z",
    fill: "#10357F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9929 18.7889L15.7632 29.2889H13.0176L10.9398 20.8889C10.9398 20.5 10.643 20.1111 10.3462 19.9556C9.52995 19.5667 8.6395 19.2556 7.82324 19.1L7.89744 18.7889H12.2755C12.8692 18.7889 13.3886 19.2556 13.4628 19.8778L14.5759 25.9445L17.2473 18.7889H19.9929ZM30.6784 25.8667C30.6784 23.0667 27.0423 22.9111 27.0423 21.7445C27.0423 21.3556 27.4133 20.9667 28.1554 20.8889C29.0459 20.8111 29.9363 20.9667 30.6784 21.3556L31.1236 19.1C30.3815 18.7889 29.4911 18.6334 28.6748 18.6334C26.1519 18.6334 24.2967 20.0334 24.2967 22.1334C24.2967 23.6111 25.5582 24.4667 26.5971 25.0111C27.636 25.5556 27.9328 25.8667 27.9328 26.3334C27.9328 27.0334 27.1165 27.3445 26.3745 27.3445C25.484 27.3445 24.5194 27.1111 23.7031 26.7223L23.2579 29.0556C24.1483 29.4445 25.1872 29.6 26.1519 29.6C28.8974 29.4445 30.6784 28.0445 30.6784 25.8667ZM37.431 29.2889H39.8056L37.7278 18.7889H35.5017C34.9823 18.7889 34.6112 19.1 34.3886 19.5667L30.53 29.2889H33.2755L33.795 27.7334H37.1342L37.431 29.2889ZM34.537 25.5556L35.8727 21.5889L36.689 25.5556H34.537ZM23.7031 18.7889L21.5512 29.2889H18.954L21.1059 18.7889H23.7031Z",
    fill: "#10357F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa.1613ac1342dd2702bf0302cb6686d839.svg";